import { Template } from '@shared/interfaces/template';
import { Observable } from 'rxjs';

export const TEMPLATES_REPOSITORY = 'TemplatesRepository';

export interface TemplatesRepository {
  url: string;

  getItems(): Observable<any>;

  add(template: Template): Observable<any>;

  edit(template: Template): Observable<any>;

  delete(item: any): Observable<any>;
}
